import {
  Box,
  Counter,
  CounterProps,
  QuickFilter,
  QuickFilterGroup,
} from '@razorpay/blade/components';
import { SalaryStructure } from 'components/SalaryStructure/types';
import { salaryStructureFiltersMap, statusFilters } from 'components/SalaryStructures/constants';
import { useFilters } from 'hooks/useFilters';
import React from 'react';

const statusColors: Record<string, CounterProps['color']> = {
  all: 'information',
  active: 'positive',
  inactive: 'notice',
};

const StatusFilter = ({ structures }: { structures: SalaryStructure[] }) => {
  const { currentFilters, applyFilter } = useFilters({
    filtersMap: { status: salaryStructureFiltersMap.status.key },
  });

  const counts = structures.reduce(
    (a, c) => ({
      ...a,
      all: a.all + 1,
      active: a.active + (c.status === 'SALARY_STRUCTURE_STATUS_ACTIVE' ? 1 : 0),
      inactive: a.inactive + (c.status === 'SALARY_STRUCTURE_STATUS_INACTIVE' ? 1 : 0),
    }),
    { all: 0, active: 0, inactive: 0 },
  );

  return (
    <QuickFilterGroup
      onChange={(e) => applyFilter('status', e.values[0])}
      defaultValue="all"
      selectionType="single"
      value={currentFilters.status}>
      <Box display="flex" gap="spacing.4" alignItems="center">
        {Object.entries(statusFilters).map(([filterKey, filterLabel]) => {
          return (
            <QuickFilter
              key={filterKey}
              value={filterKey}
              title={filterLabel}
              trailing={
                <Counter
                  value={counts[filterKey as keyof typeof counts]}
                  color={statusColors[filterKey]}
                />
              }
            />
          );
        })}
      </Box>
    </QuickFilterGroup>
  );
};

export default StatusFilter;
